export const mockResponse = {
  'internal:href': 'https://www.pega.com',
  'og:image':
    'https://www.pega.com/sites/default/files/media/images/2025-02/pega-hp-OG-2025-basic.png',
  'og:image_alt': 'Pega logo',
  'twitter:site': '@pega',
  'og:url': 'https://pega.com',
  'og:title': 'Enterprise AI decisioning and workflow automation platform',
  'og:description':
    'Pega is the leading Enterprise Transformation Company™ that helps organizations Build for Change® with enterprise AI decisioning and workflow automation.'
};

export const transformedMockResponse = {
  href: mockResponse['internal:href'],
  title: mockResponse['og:title'],
  description: mockResponse['og:description'],
  image: mockResponse['og:image'],
  image_alt: mockResponse['og:image_alt'],
  url: mockResponse['og:url']
};

export const transformedMockResponseBrokenImage = {
  href: mockResponse['internal:href'],
  title: mockResponse['og:title'],
  description: mockResponse['og:description'],
  url: mockResponse['og:url']
};

export const errorResponse = {
  href: mockResponse['internal:href'],
  error: true
};
